// Temporal Options
export const YEAR = 'lastYear'
export const SIX_MONTHS = 'last6Months'
export const THREE_MONTHS = 'last3Months'
export const MONTH = 'lastMonth'
export const WEEK = 'lastWeek'

// Type Options
export const STATS_WORDS = 'words'
export const STATS_PHRASES = 'phrases'
export const STATS_SONGS = 'songs'
export const STATS_STORIES = 'stories'
export const STATS_TYPES_FOR_WIDGET = [
  STATS_WORDS,
  STATS_PHRASES,
  STATS_SONGS,
  STATS_STORIES,
]
